import { Component, OnInit, NgZone } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as $ from "jquery";
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { CstemapiService } from '../cstemapi.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { chart } from 'highcharts';
import { point } from 'leaflet';
// import * as zingchart from 'zingchart/client/zingchart.min.js'
declare var zingchart: any;
declare var Highcharts: any;

@Component({
  selector: 'app-outputresource',
  templateUrl: './outputresource.component.html',
  styleUrls: ['./outputresource.component.scss']
})
export class OutputresourceComponent implements OnInit {
  chart1: any; chart2: any; chart3: any; chart4: any; chart5: any;
  activeIdString: any;
  sunHours: any; solarRes: any;
  flag: boolean = false;
  MonthlyAgg; dailyAgg; monthlyRan; dailyRan;
  reportType;
  monthName: any = [];
  erise: any; eset: any; lrise: any; lset: any; lday: any; sday: any;

  constructor(private zone: NgZone, private cstemapi: CstemapiService, private myRoute: Router, private auth: AuthService) {
    this.getSolarResources();

    this.MonthlyAgg = 'dhi';
    this.dailyAgg = 'dhi';
    this.monthlyRan = 'ambTemp';
    this.dailyRan = 'ambTemp';

    this.monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  }

  ngOnInit() {
    this.getSolarAngle();
    $(document).ready(function () {
      $('.sidelinks-sm').click(function () {
        $('.sidelinks').toggle();
      })
    })
  }


  ngAfterViewInit() {
    am4core.useTheme(am4themes_animated);

    this.MonthlyAgghange();
    this.DailyAgghange();
    this.monthlyRangeChange();
    this.dailyRangeChange();

    let top = document.getElementById('sun');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

  sunHoursData() {
    var d, dates = [];
    var range = [];
    for (var i = 1; i <= 12; i++) {
      d = this.daysInMonth(i, 2019);
      for (var j = 1; j <= d; j++) {
        if (i > 9) {
          // dates.push(2019 + '-' + i + '-' + j)
          dates.push(new Date(2019 + '-' + i + '-' + j))
        } else {
          // dates.push(2019 + '-0' + i + '-' + j)
          dates.push(new Date(2019 + '-0' + i + '-' + j))
        }

      }
    }

    var ydata = []
    if (dates.length == 365) {
      for (var i = 0; i < this.sunHours.sunriseAndSet.length; i++) {

        ydata.push({
          low: parseFloat(this.timeStringToFloat(this.sunHours.sunriseAndSet[i].r)),
          high: parseFloat(this.timeStringToFloat(this.sunHours.sunriseAndSet[i].s)),
          sunrise: this.sunHours.sunriseAndSet[i].r.slice(0, -3),
          sunset: this.sunHours.sunriseAndSet[i].s.slice(0, -3),
          length: this.sunHours.sunriseAndSet[i].l.slice(0, -3),
        })


        if (this.sunHours.sunriseAndSet.length == ydata.length) {
          this.solarHourChart(ydata);
        }
      }
    }
  }

  solarHourChart(ydata) {
    // console.log(ydata)
    Highcharts.chart('resourceChart1', {
      chart: {
        style: {
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
        }
      },
      title: {
        text: 'Solar Hours',
        style: this.cstemapi.h_title_format
      },
      xAxis: {
        type: 'datetime',
        labels: {
          formatter: function () {
            return Highcharts.dateFormat('%b', this.value);
          },
          style: this.cstemapi.h_x_y_format
        }
      },
      plotOptions: {
        series: {
          pointStart: Date.UTC(2019, 0, 1),
          pointInterval: 24 * 3600 * 1000
        }
      },
      yAxis: {
        title: {
          text: 'HH:MM',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        },
        tickInterval: 4,
      },
      tooltip: {
        formatter: function () {
          return '<b>' + Highcharts.dateFormat('%b %d', this.x) + '</b><br>Sunrise: <b>' + this.point.sunrise + '</b><br>Sunset: <b>' + this.point.sunset + '</b><br>Day length: <b>' + this.point.length + '</b>';
        },
        style: this.cstemapi.h_x_y_tooltip_format
      },

      series: [{
        name: 'Sunrise - Sunset',
        data: ydata,
        type: 'arearange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: Highcharts.getOptions().colors[3],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false
        }
      }]
    });
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  getSolarAngle() {
    var dObj = {
      userId: this.auth.getUserId(),
      lat: this.auth.getUserLocation().lat,
      lon: this.auth.getUserLocation().long
    };
    var api = 'reports/GetSolarAnglesRequest'
    this.cstemapi.cstemAPI(dObj).GetSolarAngle.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.sunHours = resData;
        this.erise = Date.parse(this.sunHours.earliestSunRise.replace(/-/g, ' '))
        this.eset = Date.parse(this.sunHours.earliestSunSet.replace(/-/g, ' '))
        this.lrise = Date.parse(this.sunHours.latestSunRise.replace(/-/g, ' '))
        this.lset = Date.parse(this.sunHours.latestSunSet.replace(/-/g, ' '))
        this.lday = Date.parse(this.sunHours.longestDay.replace(/-/g, ' '))
        this.sday = Date.parse(this.sunHours.shortestDay.replace(/-/g, ' '))

        this.sunHoursData();
        this.flag = true;
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Solar Angles!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  timeStringToFloat(time) {
    var hoursMinutes = time.split(/[.:]/);
    var hours = parseInt(hoursMinutes[0], 10);
    var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return (hours + minutes / 60).toFixed(2);
  }

  getSolarResources() {
    var dObj = {
      userId: this.auth.getUserId(),
      lat: this.auth.getUserLocation().lat,
      lon: this.auth.getUserLocation().long
    };
    var api = 'reports/getRadiationSummaryReport'
    this.cstemapi.cstemAPI(dObj).GetRadiationSummaryReport.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.solarRes = resData;
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Solar Angles!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  MonthlyAgghange() {
    var dObj = {
      userId: this.auth.getUserId(),
      lat: this.auth.getUserLocation().lat,
      lon: this.auth.getUserLocation().long,
      nrelDataType: this.MonthlyAgg,
      reportType: 'monthly'
    }
    var api = 'reports/getRadiationData'
    this.cstemapi.cstemAPI(dObj).GetRadiationData.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {

        var mData = [];
        if (this.MonthlyAgg == 'solarhours') {
          this.monthlyAggregate(resData.sunShineHours, 'Hours');
        } else {
          this.monthlyAggregate(resData.aggregate, 'kWh/sq.m');
        }
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  DailyAgghange() {
    var dObj = {
      userId: this.auth.getUserId(),
      lat: this.auth.getUserLocation().lat,
      lon: this.auth.getUserLocation().long,
      nrelDataType: this.dailyAgg,
      reportType: 'daily'
    }
    var api = 'reports/getRadiationData'

    this.cstemapi.cstemAPI(dObj).GetRadiationData.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {

        var dates = [];
        var d, dailydata = [], mnum, dnum;
        for (var i = 1; i <= 12; i++) {
          d = this.daysInMonth(i, 2019);
          if (i > 9) {
            mnum = i;
          } else {
            mnum = '0' + i
          }
          for (var j = 1; j <= d; j++) {
            if (j > 9) {
              dnum = j;
            } else {
              dnum = '0' + j
            }
            if (i == 2 && j == 29) {
              // console.log('leap year')
            } else {
              dates.push(2019 + '-' + mnum + '-' + dnum)
            }
          }
        }

        if (this.dailyAgg == 'solarhours') {
          if (dates.length == 365) {
            for (var i = 0; i < dates.length; i++) {
              dailydata.push([dates[i], resData.sunShineHours[i]]);
            }
          }
        } else {
          if (dates.length == 365) {
            for (var i = 0; i < dates.length; i++) {
              dailydata.push([dates[i], resData.aggregate[i]]);
            }
            resData.sunShineHours = [];
          }
        }

        if (dailydata.length == resData.sunShineHours.length || dailydata.length == resData.aggregate.length) {
          if (this.dailyAgg == 'solarhours') {
            this.dailyAggregate(dailydata, 'Hours');
          } else {
            this.dailyAggregate(dailydata, 'kWh/sq.m');
          }

          zingchart.render({
            id: 'dailyAggChart',
            data: this.chart2,
            height: '100%',
            width: '100%',
            modules: 'calendar',
          });
        }
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  monthlyRangeChange() {
    var dObj = {
      userId: this.auth.getUserId(),
      lat: this.auth.getUserLocation().lat,
      lon: this.auth.getUserLocation().long,
      nrelDataType: this.monthlyRan,
      reportType: 'monthly'
    }
    var api = 'reports/getClimateData'

    this.cstemapi.cstemAPI(dObj).GetClimateData.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      var vm = this;
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        var range = [], avg = [];
        for (var i = 0; i < resData.max.length; i++) {

          range.push([vm.monthName[i], resData.min[i], resData.max[i]]);
          avg.push([vm.monthName[i], resData.avg[i],])

          if (resData.max.length == avg.length) {
            this.monthlyRange(range, avg);
          }
        }

      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  dailyRangeChange() {
    var dObj = {
      userId: this.auth.getUserId(),
      lat: this.auth.getUserLocation().lat,
      lon: this.auth.getUserLocation().long,
      nrelDataType: this.dailyRan,
      reportType: 'daily'
    }
    var api = 'reports/getClimateData'

    this.cstemapi.cstemAPI(dObj).GetClimateData.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {

        var d, dates = [];
        var range = [], avg = [];
        for (var i = 1; i <= 12; i++) {
          d = this.daysInMonth(i, 2019);
          for (var j = 1; j <= d; j++) {
            if (i > 9) {
              // dates.push(2019 + '-' + i + '-' + j)
              dates.push(new Date(2019 + '-' + i + '-' + j))
            } else {
              // dates.push(2019 + '-0' + i + '-' + j)
              dates.push(new Date(2019 + '-0' + i + '-' + j))
            }

          }
        }

        if (dates.length == 365) {
          for (var i = 0; i < resData.max.length; i++) {

            range.push([resData.min[i], resData.max[i]]);
            avg.push([resData.avg[i],])

            if (resData.max.length == avg.length) {
              this.dailyRange(range, avg);
            }
          }
        }

      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  monthlyAggregate(mdata, yAxisName) {

    Highcharts.chart('monthlyAggChart', {
      chart: {
        renderTo: 'monthlyAggChart',
        type: 'column'
      },
      title: {
        text: ''
      },
      tooltip: {
        shared: true,
        headerFormat: '<b>{point.key}</b><br/>',
        valueDecimals: 2,
        style: this.cstemapi.h_x_y_tooltip_format
      },
      xAxis: {
        categories: this.monthName,
        crosshair: true,
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: [{
        title: {
          text: yAxisName,
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      }, {
        title: {
          text: 'Pareto',
          style: this.cstemapi.h_x_y_title_format
        },
        minPadding: 0,
        maxPadding: 0,
        max: 100,
        min: 0,
        opposite: true,
        labels: {
          format: "{value}%",
          style: this.cstemapi.h_x_y_format
        }
      }],
      // plotOptions: {
      //   column: {
      //     colorByPoint: true
      //   }
      // },
      series: [{
        type: 'pareto',
        name: 'Pareto',
        yAxis: 1,
        zIndex: 10,
        baseSeries: 1,
        showInLegend: false,
        tooltip: {
          valueSuffix: ' %'
        },
        color: Highcharts.getOptions().colors[1],
      }, {
        name: 'Aggregate',
        type: 'column',
        zIndex: 2,
        data: mdata,
        showInLegend: false,
        tooltip: {
          valueSuffix: ' ' + yAxisName
        },
        color: Highcharts.getOptions().colors[0],
      }]
    });
  }

  dailyAggregate(ddata, unit) {

    if (this.auth.getGuestUserId() == '' && this.auth.getIsGuest() == 'true') {
      this.chart2 = {
        gui: {
          contextMenu: {
            button: {
              visible: true,
            }
          }
        },
        type: 'calendar',
        title: {
        },
        options: {
          year: {
            text: '2019',
            visible: false
          },
          rows: 2,
          palette: ['none', '#3F51B5'],
          scale: {
            x: '75%',
            y: '10%',
            height: 10,
            width: '30%'
          },
          month: {
            item: {
              fontColor: 'black',
              fontSize: 14
            },
            outline: {
              borderColor: '#BDBDBD',
              active: {
                borderColor: '#BDBDBD'
              }
            }
          },
          weekday: {
            // values: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            values: ['', '', '', '', '', '', ''],
            item: {
              fontColor: 'gray',
              fontSize: 9
            }
          },
          day: {
            inactive: {
              backgroundColor: '#F5F5F5'
            }
          },
          values: ddata
        },
        plot: {
          valueBox: { // Use this object to configure the value boxes.
            fontColor: 'white',
            // fontFamily: 'Courier New',
            fontSize: 12,
            fontWeight: 'normal'
          },
          tooltip: {
            text: '%v ' + 'kWh/sq.m',
            alpha: 0.8,
            backgroundColor: '#212121',
            borderColor: '#212121',
            borderRadius: 3,
            fontColor: 'white',
            // fontFamily: 'Georgia',
            fontSize: 20,
            offsetY: -10,
            textAlign: 'center',
            textAlpha: 1
          }
        },
        plotarea: {
          marginTop: '20%',
          marginBottom: '10%'
        }
      };
    } else {
      this.chart2 = {

        type: 'calendar',
        title: {

        },
        options: {
          year: {
            text: '2019',
            visible: false
          },
          rows: 2,
          palette: ['none', '#3F51B5'],
          scale: {
            x: '75%',
            y: '10%',
            height: 10,
            width: '30%'
          },
          month: {
            item: {
              fontColor: 'black',
              fontSize: 14
            },
            outline: {
              borderColor: '#BDBDBD',
              active: {
                borderColor: '#BDBDBD'
              }
            }
          },
          weekday: {
            // values: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            values: ['', '', '', '', '', '', ''],
            item: {
              fontColor: 'gray',
              fontSize: 9
            }
          },
          day: {
            inactive: {
              backgroundColor: '#F5F5F5'
            }
          },
          values: ddata
        },
        plot: {
          valueBox: { // Use this object to configure the value boxes.
            fontColor: 'white',
            // fontFamily: 'Courier New',
            fontSize: 12,
            fontWeight: 'normal'
          },
          tooltip: {
            text: '%v ' + 'kWh/sq.m',
            alpha: 0.8,
            backgroundColor: '#212121',
            borderColor: '#212121',
            borderRadius: 3,
            fontColor: 'white',
            // fontFamily: 'Georgia',
            fontSize: 20,
            offsetY: -10,
            textAlign: 'center',
            textAlpha: 1
          }
        },
        plotarea: {
          marginTop: '20%',
          marginBottom: '10%'
        }
      };
    }
  }

  dailyRange(ranges, averages) {
    var un = ''
    if (this.dailyRan == 'windSpeed') {
      un = 'm/s';
    } else {
      un = '° C';
    }
    Highcharts.chart('dailyRangeChart', {
      title: {
        text: ''
      },
      xAxis: {
        type: 'datetime',
        labels: {
          formatter: function () {
            return Highcharts.dateFormat('%b', this.value);
          },
          style: this.cstemapi.h_x_y_format
        }
      },
      plotOptions: {
        series: {
          pointStart: Date.UTC(2019, 0, 1),
          pointInterval: 24 * 3600 * 1000
        }
      },
      yAxis: {
        title: {
          text: un,
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        xDateFormat: '<b>' + '%b %d' + '</b>',
        style: this.cstemapi.h_x_y_tooltip_format
        // valueSuffix: '°C'
      },

      series: [{
        name: 'Average',
        data: averages,
        zIndex: 1,
        marker: {
          fillColor: 'white',
          lineWidth: 2,
          lineColor: Highcharts.getOptions().colors[0]
        },
        showInLegend: false,
        tooltip: {
          valueSuffix: ' ' + un
        }
      }, {
        name: 'Min - Max',
        data: ranges,
        type: 'arearange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: Highcharts.getOptions().colors[0],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false
        },
        tooltip: {
          valueSuffix: ' ' + un
        }
      }]
    });
  }

  monthlyRange(ranges, averages) {
    var un = ''
    if (this.monthlyRan == 'windSpeed') {
      un = 'm/s';
    } else {
      un = '° C';
    }
    Highcharts.chart('monthlyRangeChart', {
      title: {
        text: ''
      },
      xAxis: {
        tickInterval: 1,
        labels: {
          enabled: true,
          formatter: function () { return ranges[this.value][0]; },
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        title: {
          text: un,
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        headerFormat: '<b>{point.key}</b><br/>',
        style: this.cstemapi.h_x_y_tooltip_format
        // valueSuffix: '°C'
      },

      series: [{
        name: 'Average',
        data: averages,
        zIndex: 1,
        marker: {
          fillColor: 'white',
          lineWidth: 2,
          lineColor: Highcharts.getOptions().colors[0]
        },
        showInLegend: false,
        tooltip: {
          valueSuffix: ' ' + un
        }
      }, {
        name: 'Min - Max',
        data: ranges,
        type: 'arearange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: Highcharts.getOptions().colors[0],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false
        },
        tooltip: {
          valueSuffix: ' ' + un
        }
      }]
    });
  }

  scrollToView(id) {
    var elmnt = document.getElementById(id);
    elmnt.scrollIntoView({
      behavior: 'smooth'
    });
  }
}
